"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
/**
 * @internal
 */
var Spinner = /** @class */ (function (_super) {
    tslib_1.__extends(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.generateSpinnerTicks = function () {
        var items = [];
        for (var i = 1; i <= 8; i += 1) {
            var className = "gd-dot-spinner-" + i;
            items.push(react_1.default.createElement("div", { className: className, key: className }));
        }
        return items;
    };
    Spinner.prototype.render = function () {
        var _a;
        var className = this.props.className;
        var spinnerClasses = classnames_1.default((_a = {
                "gd-dot-spinner": true
            },
            _a[className] = !!className,
            _a));
        return react_1.default.createElement("div", { className: spinnerClasses }, this.generateSpinnerTicks());
    };
    Spinner.defaultProps = {
        className: "",
    };
    return Spinner;
}(react_1.PureComponent));
exports.Spinner = Spinner;
//# sourceMappingURL=Spinner.js.map